import api from './api';
import { User, UserRole, AppType } from '../types';

export interface CreateUserData {
  username: string;
  password: string;
  role: UserRole;
  allowedApps?: AppType[];
}

export interface UpdatePasswordData {
  password: string;
}

export const userService = {
  async getAllUsers(): Promise<User[]> {
    const response = await api.get('/users');
    return response.data;
  },

  async getUserById(id: number): Promise<User> {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  async createUser(data: CreateUserData): Promise<User> {
    const response = await api.post('/users', data);
    return response.data;
  },

  async updateUser(id: number, data: { role?: UserRole; allowedApps?: AppType[] }): Promise<User> {
    const response = await api.patch(`/users/${id}`, data);
    return response.data;
  },

  async updateUserRole(id: number, role: UserRole): Promise<User> {
    return this.updateUser(id, { role });
  },

  async updateUserPassword(id: number, password: string): Promise<void> {
    await api.patch(`/users/${id}/password`, { password });
  },

  async deleteUser(id: number): Promise<void> {
    await api.delete(`/users/${id}`);
  },
};
